import * as React from "react";
import { logger } from "bernie-core";

import { withLocalization } from "@shared-ui/localization-context";

import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

import {
  BlossomComponentFactory,
  BlossomComponentFactoryProps,
} from "components/flexFramework/domain/BlossomComponentFactory";
import { inject } from "mobx-react";

import {
  StorefrontWizardRegionTypesContext,
  StorefrontWizardRegionTypes,
} from "components/flexComponents/PageLevelProviders/WizardContextProvider/StorefrontWizardRegionTypesContext";
import {
  getWizardLOBFlexComponents,
  getWizardLOBFormChildren,
  getNonWizardFormChildren,
  getStandaloneLOBModulesInPackages,
} from "components/shared/StorefrontWizard/StorefrontWizardUtils";

import { getTracker } from "utils/TrackingUtils";
import { PackagesStandaloneWizardModulesContext } from "components/flexComponents/PageLevelProviders/WizardContextProvider/PackagesStandaloneWizardModulesContext";
import { StorefrontWizardRegionBEXProps } from "./typings";

import { StorefrontWizardRegionBEXView } from "./components/StorefrontWizardRegionBEXView";
import { Experiment as Experiments } from "src/components/utility/experiment";

@withLocalization
@logger("StorefrontWizardRegionBEX")
@inject("wizardState", "analytics")
export class StorefrontWizardRegionBEX extends React.Component<StorefrontWizardRegionBEXProps> {
  public render() {
    const flexComponent = this.props.flexComponent;
    const context = this.props.context;
    const wizardState = this.props.wizardState;
    const analytics = this.props.analytics;
    const blossomComponent = BlossomComponentFactory.get(this.props as BlossomComponentFactoryProps);

    //default to false if device information is not available
    wizardState.globalWizardState.setIsDesktop(context.deviceInformation);

    if (!flexComponent || !flexComponent.model || !blossomComponent) {
      return null;
    }

    wizardState.globalWizardState.config.useLastSearchForMultiLOB = flexComponent.model.useLastSearchForMultiLOB;

    if (flexComponent.model.defaultLOB) {
      wizardState.globalWizardState.config.navigation.defaultLob = flexComponent.model.defaultLOB;
      wizardState.globalWizardState.config.navigation.activeLob = flexComponent.model.defaultLOB;
    }

    wizardState.globalWizardState.setLastSearchedLob();

    const children = blossomComponent.renderChildren(this.props.logger, this.props.l10n, context);

    if (children.length < 1) {
      return null;
    }

    const wizardLOBs = getWizardLOBFlexComponents(flexComponent.modules);

    const wizardFormChildren = getWizardLOBFormChildren(children);

    const otherFormChildren = getNonWizardFormChildren(children);

    wizardState.globalWizardState.config.heroImageSrc =
      flexComponent.model.backgroundImage ?? wizardState.globalWizardState.config.heroImageSrc;
    const { heroImageSrc, heroImageSrcVariant } = wizardState.globalWizardState.config;

    const lobNameMap = {
      "wizard-hotel-pwa-v2": "_Hotels",
      "wizard-flight-pwa": "_Flights",
      "wizard-package-pwa": "_Packages",
      "wizard-car-pwa": "_Cars",
      "wizard-lx-pwa": "_Lx",
      "wizard-cruise-pwa": "_Cruise",
      "wizard-thirdPartyPackage-pwa": "_ThirdPartyPackage",
      "wizard-externalLinkTab-pwa": "_ExternalLinkTab",
    };

    const trackOnChangeTab = (tabName: string, rfrrId?: string) => {
      const moduleName = flexComponent.name === "" ? "SFWizardBEX" : flexComponent.name;
      const tracker = getTracker(wizardState.canTrack, analytics, moduleName);
      const lobName = lobNameMap[tabName];
      const rfrr = `LOB_Selection_Occured${lobName ?? ""}`;
      tracker.trackEvent(`${rfrr}${rfrrId ?? ""}`);
    };

    const shouldDisplayPackageWizardMultiLOB = wizardState.globalWizardState.config.includeSingleLOBsWithinPackages;
    const wizardModules = shouldDisplayPackageWizardMultiLOB ? getStandaloneLOBModulesInPackages(children) : [];

    wizardState.globalWizardState.config.cobrandImageUrl = flexComponent.model.cobrandImageUrl;

    /**
     *
     * Note for modules below this region:
     * Modules not part of this region do not align to the form content out of the box
     * Setting the flex manager attribute brandModulePadding to bex_padding puts a spacing__twelve on the components below this region
     * This aligns them with the form content within the card on this wizard
     * On mobile, there is no card, and this same attribute puts spacing__six on these components
     */
    return (
      <StorefrontWizardRegionTypesContext.Provider value={StorefrontWizardRegionTypes.STOREFRONT_WIZARD_REGION_BEX}>
        <PackagesStandaloneWizardModulesContext.Provider value={wizardModules}>
          <Experiment name={Experiments.EXPEDIA_BRAND_REFRESH}>
            <ExperimentControl>
              <StorefrontWizardRegionBEXView
                heroImageSrc={heroImageSrc}
                context={context}
                trackOnChangeTab={trackOnChangeTab}
                wizardFormChildren={wizardFormChildren}
                wizardLOBs={wizardLOBs}
                wizardState={wizardState}
                otherFormChildren={otherFormChildren}
              />
            </ExperimentControl>
            <ExperimentVariant bucket={1}>
              <StorefrontWizardRegionBEXView
                heroImageSrc={heroImageSrcVariant || heroImageSrc}
                context={context}
                trackOnChangeTab={trackOnChangeTab}
                wizardFormChildren={wizardFormChildren}
                wizardLOBs={wizardLOBs}
                wizardState={wizardState}
                otherFormChildren={otherFormChildren}
              />
            </ExperimentVariant>
          </Experiment>
        </PackagesStandaloneWizardModulesContext.Provider>
      </StorefrontWizardRegionTypesContext.Provider>
    );
  }
}

export default StorefrontWizardRegionBEX;
